var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"success",attrs:{"small":"","tile":""},on:{"mousedown":_vm.downloadFile}},[_vm._v("Download")])
}
var staticRenderFns = []

export { render, staticRenderFns }